export const badgeTokens = {
  badge: {
    root: {
      borderRadius: '{borderRadius.sm}',
      padding: '0 6px',
      fontSize: '0.75rem',
      fontWeight: '500',
      background: '{orange.200}',
      color: '{surface.0}',
      borderColor: '{orange.100}'
    }
  }
};

export type BadgeTokens = typeof badgeTokens;
